/**
 * Given a formatter function that returns both shortened and unshortened values, returns
 * a formatter function that returns just the shortened value
 */
function toShortened (shortenedAndUnshortened) {
	return function (val) {
		return shortenedAndUnshortened(val).shortened
	}
}

/**
 * Given a formatter function that returns both shortened and unshortened values, returns
 * a formatter function that returns just the unshortened value
 */
function toUnshortened (shortenedAndUnshortened) {
	return function (val) {
		return shortenedAndUnshortened(val).unshortened
	}
}

export { toShortened }
export { toUnshortened }
